import { AdminRepositoryImpl } from "@/data/repo-Implement/admin-repository-impl";
import { AppAccountSettingRepositoryImpl } from "@/data/repo-Implement/app-account-setting-repository-impl";
import { AuthRepositoryImpl } from "@/data/repo-Implement/auth-repository-impl";
import { DebugRepositoryImpl } from "@/data/repo-Implement/debug-repository-impl";
import { HospitalRepositoryImpl } from "@/data/repo-Implement/hospital-repository-impl";
import { LoginRepositoryImpl } from "@/data/repo-Implement/login-repository-impl";
import { NoticeRepositoryImpl } from "@/data/repo-Implement/notice-repository-impl";
import { PatientRepositoryImpl } from "@/data/repo-Implement/patient-repository-impl";
import { PreRegistrationRepositoryImpl } from "@/data/repo-Implement/pre-registration-repository-impl";
// import { SelfSignupRepositoryImpl } from "@/data/repo-Implement/self-signup-repository-impl";
import { SuperAdminRepositoryImpl } from "@/data/repo-Implement/super-admin-repository-impl";
import { TreatmentRepositoryImpl } from "@/data/repo-Implement/treatment-repository-impl";
import { PatientTableInfoEntity } from "@/domain/entity/patient/patient-table-info-entity";
import { TimedCache } from "@/utils/cache/timed-cache";
import { UserPasswordManageRepositoryImpl } from "@/data/repo-Implement/user-password-reset-repositoy-impl";
import { UserRepositoryImpl } from "@/data/repo-Implement/user-repositoty-impl";
import { VersionRepositoryImpl } from "@/data/repo-Implement/version-repositoty-impl";
import { AdminSource } from "@/data/source/admin-source";
import { AppAccountSettingSource } from "@/data/source/app-account-setting-source";
import { MockAppAccountSettingSource } from "@/data/source/mock/mock-app-account-setting-source";
import { getMockAccountSetupEntryPath } from "@/data/source/mock/mock-app-account-setting-data";
import { isMockAppAccountSetting } from "@/utils/environment";
import { AuthSource } from "@/data/source/auth-source";
import { DebugSource } from "@/data/source/debug-source";
import { HospitalSource } from "@/data/source/hospital-source";
import { LoginSource } from "@/data/source/login-source";
import { NoticeSource } from "@/data/source/notice-source";
import { PatientSource } from "@/data/source/patient-source";
import { PreRegistrationSource } from "@/data/source/pre-registration-source";
import { SelfSignupSource } from "@/data/source/self-signup-source";
import { SuperAdminSource } from "@/data/source/super-admin-source";
import { TreatmentSource } from "@/data/source/treatment-source";
import { UserPasswordManageSource } from "@/data/source/user-password-reset-source";
import { UserSource } from "@/data/source/user-source";
import { VersionSource } from "@/data/source/version-source";
import { URLList } from "@/data/url_list";
import { AdminRepository } from "@/domain/repository/admin-repository";
import { GetAccountSetupIdentityUsecase } from "@/domain/usecase/app-account-setting/get-account-setup-identity-usecase";
import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { AuthRepository } from "@/domain/repository/auth-repository";
import { DebugRepository } from "@/domain/repository/debug-repository";
import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { LoginRepository } from "@/domain/repository/login-repository";
import { NoticeRepository } from "@/domain/repository/notice-repository";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { PreRegistrationRepository } from "@/domain/repository/pre-registration-repository";
// import { SelfSignupRepository } from "@/domain/repository/self-signup-repository";
import { SuperAdminRepository } from "@/domain/repository/super-admin-repository";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { UserPasswordManageRepository } from "@/domain/repository/user-password-reset-repository";
import { UserRepository } from "@/domain/repository/user-repository";
import { VersionRepository } from "@/domain/repository/version-repository";
import { ActivateDoctorUsecase } from "@/domain/usecase/admin/doctor-manage/activate-doctor-usecase";
import { CreateDoctorUsecase } from "@/domain/usecase/admin/doctor-manage/create-doctor-usecase";
import { DeactivateDoctorUsecase } from "@/domain/usecase/admin/doctor-manage/deactivate-doctor-usecase";
import { FetchDoctorListUsecase } from "@/domain/usecase/admin/doctor-manage/fetch-doctor-list-usecase";
import { FetchDoctorUsecase } from "@/domain/usecase/admin/doctor-manage/fetch-doctor-usecase";
import { SendPasswordChangeEmailToDoctorUsecase } from "@/domain/usecase/admin/doctor-manage/send-password-change-email-to-doctor-usecase";
import { UpdateDoctorUsecase } from "@/domain/usecase/admin/doctor-manage/update-doctor-usecase";
import { AddHospitalUsecase } from "@/domain/usecase/admin/hospital-manage/add-hospital-usecase";
import { DeleteHospitalUsecase } from "@/domain/usecase/admin/hospital-manage/delete-hospital-usecase";
import { FetchHospitalListUsecase } from "@/domain/usecase/admin/hospital-manage/fetch-hospital-list-usecase";
import { AddNoticeUsecase } from "@/domain/usecase/admin/notice-manage/add-notice-usecase";
import { DeleteNoticeByUuidUsecase } from "@/domain/usecase/admin/notice-manage/delete-notice-by-uuid-usecase";
import { FetchNoticeDetailUsecase } from "@/domain/usecase/admin/notice-manage/fetch-notice-detail-usecase";
import { FetchNoticeListUsecase } from "@/domain/usecase/admin/notice-manage/fetch-notice-list-usecase";
import { UpdateNoticeByUuidUsecase } from "@/domain/usecase/admin/notice-manage/update-notice-by-uuid-usecase";
import { FetchActionLogUsecase } from "@/domain/usecase/admin/action-log-usecase";
import { FetchOperationLogUsecase } from "@/domain/usecase/admin/operation-log-usecase";
import { FetchPatientListUsecase as AdminFetchPatientListUsecase } from "@/domain/usecase/admin/patient-manage/fetch-patient-list-usecase";
import { AddAppAccountUsecase } from "@/domain/usecase/app-account-setting/add-app-account-usecase";
import { CheckUserIdAvailableUsecase } from "@/domain/usecase/app-account-setting/check-user-id-available-usecase";
import { CheckUserNameBySmsTokenForLoginAccountUsecase } from "@/domain/usecase/app-account-setting/check-user-name-by-sms-token-for-login-account-usecase";
import { FetchConsentTermsFileUsecase } from "@/domain/usecase/app-account-setting/fetch-consent-terms-file-usecase";
import { IsExistAuthorizedTokenUsecase } from "@/domain/usecase/app-account-setting/is-exist-authorized-token-usecase";
import { RemoveAuthorizedTokenUsecase } from "@/domain/usecase/app-account-setting/remove-authorized-token-usecase";
import { SaveTermsConsentUsecase } from "@/domain/usecase/app-account-setting/save-terms-consent-usecase";
import { SetAuthorizedTokenUsecase } from "@/domain/usecase/app-account-setting/set-authorized-token-usecase";
import { DebugMaintenanceUsecase } from "@/domain/usecase/debug/debug-maintenance-usecase";
import { BrowserEnvironmentCheckUsecase } from "@/domain/usecase/common/auth/browser-environment-check-usecase";
import { ExchangeAESKeyUsecase } from "@/domain/usecase/common/auth/exchange-aes-key-usecase";
import { InitDoctorPasswordSettingUsecase } from "@/domain/usecase/common/auth/init-doctor-password-setting-usecase";
import { TimeZoneCheckUsecase } from "@/domain/usecase/common/auth/time-zone-check-useacse";
import { UserTokenCheckUsecase } from "@/domain/usecase/common/auth/user-token-check-usecase";
import { DownloadUserManualUsecase } from "@/domain/usecase/common/download-user-guide/download-user-manual-usecase";
import { ResetPasswordByLinkUsecase } from "@/domain/usecase/common/find-password/reset-password-by-link-usecase";
import { SendEmailIncludePasswordResetLinkUsecase } from "@/domain/usecase/common/find-password/send-email-include-password-reset-link-usecase";
import { ValidUserAuthCodeUsecase } from "@/domain/usecase/common/find-password/valid-user-auth-code-usecase";
import { GetMedicalDeviceInfoUrlUsecase } from "@/domain/usecase/common/footer/get-medical-device-info-url-usecase";
import { GetPrivacyPolicyUrlUsecase } from "@/domain/usecase/common/footer/get-privacy-policy-url-usecase";
import { GetTermsOfServiceUrlUsecase } from "@/domain/usecase/common/footer/get-terms-of-service-url-usecase";
import { FetchHeaderUserInfoUsecase } from "@/domain/usecase/common/header/fetch-header-user-info-usecase";
import { FetchUserInfoUsecase } from "@/domain/usecase/common/header/fetch-user-info-usecase";
import { ChangePasswordWhenLoginUsecase } from "@/domain/usecase/common/login/change-password-when-login-usecase";
import { LoginUsecase } from "@/domain/usecase/common/login/login-usecase";
import { LogoutUsecase } from "@/domain/usecase/common/login/logout-usecase";
import { FetchActivityChartDataUsecase } from "@/domain/usecase/common/treatment-detail/fetch-activity-chart-data-usecase";
import { FetchTreatmentDetailUsecase } from "@/domain/usecase/common/treatment-detail/fetch-treatment-detail-usecase";
import { ModifyTreatmentMemoUsecase } from "@/domain/usecase/common/treatment-detail/modify-treatment-memo-usecase";
import { VersionCheckUsecase } from "@/domain/usecase/common/version-check-usecase";
import { ActivatePatientUsecase } from "@/domain/usecase/doctor/home/activate-patient-usecase";
import { DeletePreRegistrationPatientUsecase } from "@/domain/usecase/doctor/home/delete-pre-registration-patient-usecase";
import { GetPreRegistrationListUsecase } from "@/domain/usecase/doctor/home/get-pre-registration-list-usecase";
import { DeactivatePatientUsecase } from "@/domain/usecase/doctor/patient-manage/deactivate-patient-usecase";
import { EnrollPatientUsecase } from "@/domain/usecase/doctor/patient-manage/enroll-patient-usecase";
import { FetchPatientListUsecase } from "@/domain/usecase/doctor/patient-manage/fetch-patient-list-usecase";
import { FetchPatientUsecase } from "@/domain/usecase/doctor/patient-manage/fetch-patient-usecase";
import { UpdatePatientInfoUsecase } from "@/domain/usecase/doctor/patient-manage/update-patient-info-usecase";
import { AddTreatmentUsecase } from "@/domain/usecase/doctor/treatment/add-treatment-usecase";
import { FetchPatientTotalTreatmentListUsecase } from "@/domain/usecase/doctor/treatment/fetch-patient-total-treatment-list-usecase";
import { FetchPatientTreatmentListUsecase } from "@/domain/usecase/doctor/treatment/fetch-patient-treatment-list-usecase";
import { ResendSMSForSetupAccountUsecase } from "@/domain/usecase/doctor/treatment/resend-sms-for-setup-account-usecase";
import { TerminateTreatmentUsecase } from "@/domain/usecase/doctor/treatment/terminate-treatment-usecase";
import { clearPasswordChangeCookies, clearUserRoleCookie } from "@/utils/cookie-utils";
import { cryptoUtil } from "@/utils/crypto/crypto";
import { browserStorageKeyProvider } from "@/utils/crypto/browser-storage-key-provider";
import { sessionKeyHolder } from "@/utils/crypto/session-key-holder";
import { restoreSessionKeyBeforeRender } from "@/init/restore-session-key-before-render";
import { LOGIN_PATH, FETCH_API_CLIENT_ENCRYPT_URL_STR } from "@/utils/global-constants";
import { decompressGzipData, isGzipUrl } from "@/utils/gzip-utils";
import {
  FetchApiClient,
  FetchApiClientMethod,
  HttpError,
  TokenTransportConfig,
  TokenTransportType,
} from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATErrorModel, SATErrorType, SATResult } from "@sadtx/sat-error";
import { SecureStorageService } from "@sadtx/secure-storage";

//MARK:- Self Sign up
// type SelfSignupRequester = {
//   validHospitalCode: (
//     hospitalCode: string
//   ) => Promise<SATResult<SelfSignupHospitalInfo | null, SATError>>;
//   validGuardianInfo: () => Promise<SATResult<SelfSignupGuardianInfo | null, SATError>>;
//   validPatientInfo: () => Promise<SATResult<SelfSignupPatientInfo | null, SATError>>;
//   validSignupInfo: () => Promise<SATResult<SelfSignupResponseDto | null, SATError>>;
//   saveGuardianInfo: (guardian: SelfSignupGuardianInfo) => Promise<SATResult<void, SATError>>;
//   savePatientInfo: (patient: SelfSignupPatientInfo) => Promise<SATResult<void, SATError>>;
//   issuePhoneAuthCode: (
//     phoneNumber: string
//   ) => Promise<SATResult<{ token: string }, SATError>>;
//   validPhoneAuthCode: (code: string) => Promise<SATResult<{ token: string }, SATError>>;
//   requestPreSingup: () => Promise<SATResult<void, SATError>>;
// };

// let selfSignupRepoInstance: SelfSignupRepository | null = null;
// let phoneAuthToken: string | null = null;
// let selfSignupToken: string | null = null;

// export let selfSignupRequester: SelfSignupRequester;

/**
 * 애플리케이션의 핵심 인스턴스들을 초기화하고 관리하는 모듈
 *
 * 이 모듈은 SecureStorage와 RsaAesGcmCrypto 인스턴스의 싱글톤 생명주기를 관리합니다.
 * 초기화는 한 번만 수행되며, 이후 요청에서는 이미 생성된 인스턴스를 반환합니다.
 *
 * @module initializeInstances
 */

// MARK: - Common Usecase
export let exchangeAESKeyUsecase: ExchangeAESKeyUsecase;
export let initDoctorPasswordSettingUsecase: InitDoctorPasswordSettingUsecase;
export let userTokenCheckUsecase: UserTokenCheckUsecase;
export let resetPasswordByLinkUsecase: ResetPasswordByLinkUsecase;
export let sendEmailIncludePasswordResetLinkUsecase: SendEmailIncludePasswordResetLinkUsecase;
export let validUserAuthCodeUsecase: ValidUserAuthCodeUsecase;
export let fetchHeaderUserInfoUsecase: FetchHeaderUserInfoUsecase;
export let fetchUserInfoUsecase: FetchUserInfoUsecase;
export let changePasswordWhenLoginUsecase: ChangePasswordWhenLoginUsecase;
export let loginUsecase: LoginUsecase;
export let logoutUsecase: LogoutUsecase;
export let fetchActivityChartDataUsecase: FetchActivityChartDataUsecase;
export let fetchTreatmentDetailUsecase: FetchTreatmentDetailUsecase;
export let modifyTreatmentMemoUsecase: ModifyTreatmentMemoUsecase;
export let versionCheckUsecase: VersionCheckUsecase;
export let downloadUserManualUsecase: DownloadUserManualUsecase;
export let browserEnvironmentCheckUsecase: BrowserEnvironmentCheckUsecase;
export let getMedicalDeviceInfoUrlUsecase: GetMedicalDeviceInfoUrlUsecase;
export let getPrivacyPolicyUrlUsecase: GetPrivacyPolicyUrlUsecase;
export let getTermsOfServiceUrlUsecase: GetTermsOfServiceUrlUsecase;

// MARK: - Admin Usecase
export let activateDoctorUsecase: ActivateDoctorUsecase;
export let createDoctorUsecase: CreateDoctorUsecase;
export let deactivateDoctorUsecase: DeactivateDoctorUsecase;
export let fetchDoctorListUsecase: FetchDoctorListUsecase;
export let fetchDoctorUsecase: FetchDoctorUsecase;
export let sendPasswordChangeEmailToDoctorUsecase: SendPasswordChangeEmailToDoctorUsecase;
export let updateDoctorUsecase: UpdateDoctorUsecase;
export let addHospitalUsecase: AddHospitalUsecase;
export let deleteHospitalUsecase: DeleteHospitalUsecase;
export let fetchHospitalListUsecase: FetchHospitalListUsecase;
export let addNoticeUsecase: AddNoticeUsecase;
export let fetchNoticeDetailUsecase: FetchNoticeDetailUsecase;
export let fetchNoticeListUsecase: FetchNoticeListUsecase;
export let updateNoticeByUuidUsecase: UpdateNoticeByUuidUsecase;
export let deleteNoticeByUuidUsecase: DeleteNoticeByUuidUsecase;
export let fetchOperationLogUsecase: FetchOperationLogUsecase;
export let fetchActionLogUsecase: FetchActionLogUsecase;
export let adminFetchPatientListUsecase: AdminFetchPatientListUsecase;

// MARK: - Doctor Usecase
export let activatePatientUsecase: ActivatePatientUsecase;
export let deletePreRegistrationPatientUsecase: DeletePreRegistrationPatientUsecase;
export let getPreRegistrationListUsecase: GetPreRegistrationListUsecase;
export let deactivatePatientUsecase: DeactivatePatientUsecase;
export let enrollPatientUsecase: EnrollPatientUsecase;
export let fetchPatientListUsecase: FetchPatientListUsecase;
export let fetchPatientUsecase: FetchPatientUsecase;
export let updatePatientInfoUsecase: UpdatePatientInfoUsecase;
export let addTreatmentUsecase: AddTreatmentUsecase;
export let fetchPatientTotalTreatmentListUsecase: FetchPatientTotalTreatmentListUsecase;
export let fetchPatientTreatmentListUsecase: FetchPatientTreatmentListUsecase;
export let resendSMSForSetupAccountUsecase: ResendSMSForSetupAccountUsecase;
export let terminateTreatmentUsecase: TerminateTreatmentUsecase;

// MARK: - App Account Setting Usecase
export let addAppAccountUsecase: AddAppAccountUsecase;
export let checkUserIdAvailableUsecase: CheckUserIdAvailableUsecase;
export let getAccountSetupIdentityUsecase: GetAccountSetupIdentityUsecase;
export let checkUserNameBySmsTokenForLoginAccountUsecase: CheckUserNameBySmsTokenForLoginAccountUsecase;
export let fetchConsentTermsFileUsecase: FetchConsentTermsFileUsecase;
export let isExistAuthorizedTokenUsecase: IsExistAuthorizedTokenUsecase;
export let removeAuthorizedTokenUsecase: RemoveAuthorizedTokenUsecase;
export let saveTermsConsentUsecase: SaveTermsConsentUsecase;
export let setAuthorizedTokenUsecase: SetAuthorizedTokenUsecase;

// MARK: - Self Signup Usecase
// export let clearUserDataUsecase: ClearUserDataUsecase;
// export let createPreRegistrationUsecase: CreatePreRegistrationUsecase;
// export let exchangeSecretKeyByTokenUsecase: ExchangeSecretKeyByTokenUsecase;
// export let issuePhoneAuthCodeUsecase: IssuePhoneAuthCodeUsecase;
// export let loadSignupTotalInfoUsecase: LoadSignupTotalInfoUsecase;
// export let saveGuardianInfoUsecase: SaveGuardianInfoUsecase;
// export let saveHospitalInfoUsecase: SaveHospitalInfoUsecase;
// export let savePatientInfoUsecase: SavePatientInfoUsecase;
// export let validPhoneAuthCodeUsecase: ValidPhoneAuthCodeUsecase;
// export let validateHospitalInfoUsecase: ValidateHospitalInfoUsecase;

// MARK: - Common Usecase
export let timeZoneCheckUsecase: TimeZoneCheckUsecase;

// MARK: - Debug / Maintenance Usecase
export let debugMaintenanceUsecase: DebugMaintenanceUsecase;

// export { tokenReissuSuccessEventManager };
// export { sseManager };

// MARK: - SecureStorage Make
// 번들 고정 키 대신 브라우저 임시 키(non-extractable, IndexedDB 보관)로 암복호화합니다.
// SecureStorageService의 initKey 인자는 키 원본이 아닌 키 이름으로만 전달되며 암복호화에는 쓰이지 않습니다.
const secureStorageInstance = new SecureStorageService(
  "browser-storage-key",
  async (data: string) => cryptoUtil.encrypt(data, await browserStorageKeyProvider.getOrCreateKey()),
  async (data: string) => cryptoUtil.decrypt(data, await browserStorageKeyProvider.getOrCreateKey()),
);

// MARK: - 환자 목록 캐시 (10초, 메모리 전용이라 새로고침 시 비워짐)
const PATIENT_LIST_CACHE_TTL_MS = 10_000;
const patientListCache = new TimedCache<SATResult<PatientTableInfoEntity[], SATError>>(
  PATIENT_LIST_CACHE_TTL_MS,
);

// MARK: - 세션 키 정리 (로그아웃/자동 로그아웃 공용)
export const clearSecureAesKey = async (): Promise<void> => {
  sessionKeyHolder.clear();
  patientListCache.invalidate();
};

// MARK: - 세션 키 조회 (메모리에 없으면 쿠키 기반 재교환으로 복원)
const getSessionAesKey = async (): Promise<CryptoKey> => {
  const aesSecretKey = await sessionKeyHolder.getOrRestoreKey();
  if (!aesSecretKey) {
    console.log("[INITIALIZE_INSTANCES] :: AES secret key not found");
    throw new SATErrorModel.FailToGetSecretKey();
  }
  return aesSecretKey;
};

const handleTokenReissueFailure = async (): Promise<void> => {
  console.error("[INITIALIZE_INSTANCES] :: handleTokenReissueFailure :: 토큰 재발급 최종 실패");

  if (typeof window === "undefined") {
    return;
  }

  await clearSecureAesKey();
  clearUserRoleCookie();
  clearPasswordChangeCookies();

  // if (window.location.pathname !== LOGIN_PATH) {
  //   window.location.replace(LOGIN_PATH);
  // }
};

// MARK: - fetchApiClient Make
const tokenTransportConfig: TokenTransportConfig = {
  tokenTransportType: TokenTransportType.WEB_COOKIE,
};

const fetchApiClient: FetchApiClientMethod = new FetchApiClient(
  tokenTransportConfig,
  true, // true(로그 미출력), prod는 false(로그 출력)
  {
    checkTokenExpiredError: (error: HttpError) => {
      // 토큰 재발급 요청이 실패했을때 다 토큰 재발급 요청을 반복적으로 시도하지 않도록 처리
      const requestUrl = error.config?.url ?? "";
      if (requestUrl.includes(URLList.USER.RESET_TOKEN)) {
        console.log(
          "[INITIALIZE_INSTANCES] :: checkTokenExpiredError :: Ignore refresh endpoint failure",
        );
        return false;
      }

      console.log("[INITIALIZE_INSTANCES] :: Start checkTokenExpiredError", error);
      const satError = errorConverter.convertError(error);
      console.log("[INITIALIZE_INSTANCES] :: satError", satError);
      if (satError.type === SATErrorType.ExpiredToken) {
        console.log("[INITIALIZE_INSTANCES] :: checkTokenExpiredError :: Expired Token");
        return true;
      }
      console.log("[INITIALIZE_INSTANCES] :: checkTokenExpiredError :: Not Expired Token");
      return false;
    },
    tokenReissueUrl: URLList.USER.RESET_TOKEN,
    errorMappers: {
      urlRequestIsEmpty: new SATErrorModel.UrlRequestIsEmpty("요청 정보가 없습니다."),
    },
  },
  {
    //MARK:- Request Interceptor
    encryptUrlStr: FETCH_API_CLIENT_ENCRYPT_URL_STR,
    requestInterceptor: async (config) => {
      const aesSecretKey = await getSessionAesKey();

      try {
        // 문자열/객체 모두 안전하게 판별 및 평문 생성
        if (config.data == null) {
          return config;
        }

        let isAlreadyEncrypted = false;
        let plainString: string;

        if (typeof config.data === "string") {
          try {
            const parsed = JSON.parse(config.data);
            isAlreadyEncrypted =
              !!parsed && typeof parsed === "object" && "securePayload" in parsed;
            plainString = typeof parsed === "string" ? parsed : JSON.stringify(parsed);
          } catch {
            isAlreadyEncrypted = false;
            plainString = config.data;
          }
        } else if (typeof config.data === "object") {
          isAlreadyEncrypted =
            !!config.data && "securePayload" in (config.data as Record<string, unknown>);
          plainString = JSON.stringify(config.data);
        } else {
          isAlreadyEncrypted = false;
          plainString = String(config.data);
        }

        console.log("[INITIALIZE_INSTANCES] :: isAlreadyEncrypted", isAlreadyEncrypted);
        if (isAlreadyEncrypted) {
          console.log("[INITIALIZE_INSTANCES] :: data is already encrypted");
          return config;
        }

        const encryptedData = await cryptoUtil.encrypt(plainString, aesSecretKey);

        config.data = {
          securePayload: encryptedData,
        };
        return config;
      } catch (e) {
        console.error("[INITIALIZE_INSTANCES] :: Fail to encrypt data", e);
        throw new SATErrorModel.FailToEncryptData("Fail to encrypt data" + e);
      }
    },
    //MARK:- Response Interceptor
    responseInterceptor: async (response) => {
      const data = response.data;
      const cipherText = data.securePayload;

      if (!cipherText) {
        console.log("[INITIALIZE_INSTANCES] :: cipherText not found");
        return response;
      }

      const aesSecretKey = await getSessionAesKey();

      try {
        const decryptedData = await cryptoUtil.decrypt(cipherText, aesSecretKey);

        // URL에 gzip이 포함되어 있으면 압축 해제
        const requestUrl = response.config?.url ?? "";
        const finalData = isGzipUrl(requestUrl)
          ? await decompressGzipData(decryptedData)
          : decryptedData;

        return {
          ...response,
          data: JSON.parse(finalData),
        };
      } catch (e) {
        console.error("[INITIALIZE_INSTANCES] :: Fail to decrypt data", e);
        throw new SATErrorModel.FailToDecryptData("Fail to decrypt data" + e);
      }
    },
  },
  undefined,
  handleTokenReissueFailure,
);

/**
 * 애플리케이션의 핵심 인스턴스들을 초기화합니다.
 *
 * 이 함수는 다음과 같은 특징이 있습니다:
 * - 이미 초기화된 경우 추가 초기화를 수행하지 않습니다.
 * - 초기화가 진행 중인 경우 기존 초기화 Promise를 반환합니다.
 * - 초기화 실패 시 모든 상태를 초기화하여 재시도가 가능하도록 합니다.
 *
 * @param {boolean} [isUseCookie=false] - 쿠키 사용 여부 설정
 * @returns {Promise<void>} 초기화된 인스턴스들
 * @throws {Error} 초기화 과정에서 오류가 발생한 경우
 */
export const initializeInstances = (): Promise<void> => {
  // MARK: - Source Maker
  const versionSource: VersionSource = new VersionSource(fetchApiClient);
  const authSource: AuthSource = new AuthSource(fetchApiClient, cryptoUtil, sessionKeyHolder);
  // 새로고침·새 탭에서 메모리 세션 키가 비면 쿠키 기반으로 재교환 (서버는 동일한 키를 반환)
  sessionKeyHolder.setRestorer(async () => (await authSource.exchangeSecretKeyByCookie()).isSuccess);
  const hospitalSource: HospitalSource = new HospitalSource(fetchApiClient);
  const preRegistrationSource: PreRegistrationSource = new PreRegistrationSource(fetchApiClient);
  const userSource: UserSource = new UserSource(fetchApiClient);
  const loginSource: LoginSource = new LoginSource(fetchApiClient);
  const patientSource: PatientSource = new PatientSource(fetchApiClient);
  const treatmentSource: TreatmentSource = new TreatmentSource(fetchApiClient);
  // 보호자 계정 생성 플로우 Mock (development + VITE_MOCK_APP_ACCOUNT_SETTING=true 전용)
  const appAccountSettingSource: AppAccountSettingSource = isMockAppAccountSetting
    ? new MockAppAccountSettingSource(fetchApiClient, secureStorageInstance, browserStorageKeyProvider)
    : new AppAccountSettingSource(fetchApiClient, secureStorageInstance, browserStorageKeyProvider);
  if (isMockAppAccountSetting) {
    console.warn(
      "[INITIALIZE_INSTANCES] :: 보호자 계정 생성 플로우가 Mock Source 로 동작합니다. API 호출 없음.\n" +
        `  진입 URL: ${window.location.origin}${getMockAccountSetupEntryPath()}`,
    );
  }
  const userAuthCodeSource: UserPasswordManageSource = new UserPasswordManageSource(fetchApiClient);
  const adminSource: AdminSource = new AdminSource(fetchApiClient);
  const superAdminSource: SuperAdminSource = new SuperAdminSource(fetchApiClient);
  const noticeSource: NoticeSource = new NoticeSource(fetchApiClient);
  const debugSource: DebugSource = new DebugSource(fetchApiClient);
  // const selfSignupSource: SelfSignupSource = new SelfSignupSource(secureStorageInstance);

  // MARK: - Repository Maker
  const versionRepository: VersionRepository = new VersionRepositoryImpl(versionSource);

  const authRepo: AuthRepository = new AuthRepositoryImpl(authSource, userAuthCodeSource);
  // const selfSignupRepo: SelfSignupRepository = new SelfSignupRepositoryImpl(selfSignupSource);
  const preRegistrationRepo: PreRegistrationRepository = new PreRegistrationRepositoryImpl(
    preRegistrationSource,
  );
  const hospitalRepo: HospitalRepository = new HospitalRepositoryImpl(hospitalSource);
  const loginRepo: LoginRepository = new LoginRepositoryImpl(loginSource, sessionKeyHolder);
  const userRepo: UserRepository = new UserRepositoryImpl(userSource, patientSource);
  const patientRepo: PatientRepository = new PatientRepositoryImpl(patientSource, userSource);
  const treatmentRepo: TreatmentRepository = new TreatmentRepositoryImpl(treatmentSource);
  const appAccountSettingRepo: AppAccountSettingRepository = new AppAccountSettingRepositoryImpl(
    appAccountSettingSource,
  );
  const userPasswordManageRepo: UserPasswordManageRepository = new UserPasswordManageRepositoryImpl(
    userAuthCodeSource,
  );
  const adminRepo: AdminRepository = new AdminRepositoryImpl(adminSource);
  const superAdminRepo: SuperAdminRepository = new SuperAdminRepositoryImpl(superAdminSource);
  const noticeRepo: NoticeRepository = new NoticeRepositoryImpl(noticeSource);
  const debugRepo: DebugRepository = new DebugRepositoryImpl(debugSource);
  // selfSignupRepoInstance = selfSignupRepo;

  // MARK: - Usecase Maker & Assignment
  exchangeAESKeyUsecase = new ExchangeAESKeyUsecase(authRepo);
  initDoctorPasswordSettingUsecase = new InitDoctorPasswordSettingUsecase(userPasswordManageRepo);
  userTokenCheckUsecase = new UserTokenCheckUsecase(authRepo);
  resetPasswordByLinkUsecase = new ResetPasswordByLinkUsecase(userPasswordManageRepo);
  sendEmailIncludePasswordResetLinkUsecase = new SendEmailIncludePasswordResetLinkUsecase(
    userPasswordManageRepo,
  );
  validUserAuthCodeUsecase = new ValidUserAuthCodeUsecase(userPasswordManageRepo);
  fetchHeaderUserInfoUsecase = new FetchHeaderUserInfoUsecase(userRepo);
  fetchUserInfoUsecase = new FetchUserInfoUsecase(userRepo);
  changePasswordWhenLoginUsecase = new ChangePasswordWhenLoginUsecase(userRepo);
  loginUsecase = new LoginUsecase(loginRepo, authRepo);
  logoutUsecase = new LogoutUsecase(loginRepo, patientListCache);
  fetchActivityChartDataUsecase = new FetchActivityChartDataUsecase(treatmentRepo);
  fetchTreatmentDetailUsecase = new FetchTreatmentDetailUsecase(treatmentRepo);
  modifyTreatmentMemoUsecase = new ModifyTreatmentMemoUsecase(treatmentRepo);
  versionCheckUsecase = new VersionCheckUsecase(versionRepository);
  downloadUserManualUsecase = new DownloadUserManualUsecase();
  browserEnvironmentCheckUsecase = new BrowserEnvironmentCheckUsecase();
  getMedicalDeviceInfoUrlUsecase = new GetMedicalDeviceInfoUrlUsecase();
  getPrivacyPolicyUrlUsecase = new GetPrivacyPolicyUrlUsecase();
  getTermsOfServiceUrlUsecase = new GetTermsOfServiceUrlUsecase();

  activateDoctorUsecase = new ActivateDoctorUsecase(adminRepo);
  createDoctorUsecase = new CreateDoctorUsecase(adminRepo);
  deactivateDoctorUsecase = new DeactivateDoctorUsecase(adminRepo);
  fetchDoctorListUsecase = new FetchDoctorListUsecase(adminRepo);
  fetchDoctorUsecase = new FetchDoctorUsecase(adminRepo);
  sendPasswordChangeEmailToDoctorUsecase = new SendPasswordChangeEmailToDoctorUsecase(adminRepo);
  updateDoctorUsecase = new UpdateDoctorUsecase(adminRepo);
  addHospitalUsecase = new AddHospitalUsecase(hospitalRepo);
  deleteHospitalUsecase = new DeleteHospitalUsecase(hospitalRepo);
  fetchHospitalListUsecase = new FetchHospitalListUsecase(hospitalRepo);
  addNoticeUsecase = new AddNoticeUsecase(noticeRepo);
  fetchNoticeDetailUsecase = new FetchNoticeDetailUsecase(noticeRepo);
  fetchNoticeListUsecase = new FetchNoticeListUsecase(noticeRepo);
  updateNoticeByUuidUsecase = new UpdateNoticeByUuidUsecase(noticeRepo);
  deleteNoticeByUuidUsecase = new DeleteNoticeByUuidUsecase(noticeRepo);
  fetchOperationLogUsecase = new FetchOperationLogUsecase(superAdminRepo);
  fetchActionLogUsecase = new FetchActionLogUsecase(superAdminRepo);
  adminFetchPatientListUsecase = new AdminFetchPatientListUsecase(adminRepo);

  activatePatientUsecase = new ActivatePatientUsecase(patientRepo, patientListCache);
  deletePreRegistrationPatientUsecase = new DeletePreRegistrationPatientUsecase(
    preRegistrationRepo,
  );
  getPreRegistrationListUsecase = new GetPreRegistrationListUsecase(preRegistrationRepo);
  enrollPatientUsecase = new EnrollPatientUsecase(userRepo, patientListCache);
  fetchPatientListUsecase = new FetchPatientListUsecase(patientRepo, patientListCache);
  fetchPatientUsecase = new FetchPatientUsecase(patientRepo);
  updatePatientInfoUsecase = new UpdatePatientInfoUsecase(patientRepo, patientListCache);
  addTreatmentUsecase = new AddTreatmentUsecase(treatmentRepo, patientListCache);
  fetchPatientTotalTreatmentListUsecase = new FetchPatientTotalTreatmentListUsecase(treatmentRepo);
  fetchPatientTreatmentListUsecase = new FetchPatientTreatmentListUsecase(treatmentRepo);
  resendSMSForSetupAccountUsecase = new ResendSMSForSetupAccountUsecase(patientRepo);
  terminateTreatmentUsecase = new TerminateTreatmentUsecase(treatmentRepo, patientListCache);
  deactivatePatientUsecase = new DeactivatePatientUsecase(
    patientRepo,
    terminateTreatmentUsecase,
    patientListCache,
  );

  addAppAccountUsecase = new AddAppAccountUsecase(appAccountSettingRepo);
  checkUserIdAvailableUsecase = new CheckUserIdAvailableUsecase(appAccountSettingRepo);
  checkUserNameBySmsTokenForLoginAccountUsecase = new CheckUserNameBySmsTokenForLoginAccountUsecase(
    appAccountSettingRepo,
  );
  getAccountSetupIdentityUsecase = new GetAccountSetupIdentityUsecase(appAccountSettingRepo);
  fetchConsentTermsFileUsecase = new FetchConsentTermsFileUsecase(appAccountSettingRepo);
  isExistAuthorizedTokenUsecase = new IsExistAuthorizedTokenUsecase(appAccountSettingRepo);
  removeAuthorizedTokenUsecase = new RemoveAuthorizedTokenUsecase(appAccountSettingRepo);
  saveTermsConsentUsecase = new SaveTermsConsentUsecase(appAccountSettingRepo);
  setAuthorizedTokenUsecase = new SetAuthorizedTokenUsecase(appAccountSettingRepo);
  timeZoneCheckUsecase = new TimeZoneCheckUsecase(authRepo);
  debugMaintenanceUsecase = new DebugMaintenanceUsecase(debugRepo);

  // clearUserDataUsecase = new ClearUserDataUsecase(selfSignupRepo);
  // createPreRegistrationUsecase = new CreatePreRegistrationUsecase(preRegistrationRepo);
  // exchangeSecretKeyByTokenUsecase = new ExchangeSecretKeyByTokenUsecase(authRepo);
  // issuePhoneAuthCodeUsecase = new IssuePhoneAuthCodeUsecase(userPasswordManageRepo);
  // loadSignupTotalInfoUsecase = new LoadSignupTotalInfoUsecase(selfSignupRepo);
  // saveGuardianInfoUsecase = new SaveGuardianInfoUsecase(selfSignupRepo);
  // saveHospitalInfoUsecase = new SaveHospitalInfoUsecase(selfSignupRepo);
  // savePatientInfoUsecase = new SavePatientInfoUsecase(selfSignupRepo);
  // validPhoneAuthCodeUsecase = new ValidPhoneAuthCodeUsecase(userPasswordManageRepo);
  // validateHospitalInfoUsecase = new ValidateHospitalInfoUsecase(hospitalRepo);

  // selfSignupRequester = {
  //   async validHospitalCode(hospitalCode: string) {
  //     const result = await validateHospitalInfoUsecase.execute(hospitalCode);
  //     if (result.isFailure || !result.value) {
  //       return SATResult.failure(result.error);
  //     }
  //     if (!result.value.isValid) {
  //       return SATResult.failure(
  //         new SATErrorModel.FailToGetItem("유효하지 않은 병원 코드입니다.")
  //       );
  //     }

  //     const hospitalInfo: SelfSignupHospitalInfo = {
  //       code: hospitalCode,
  //       name: result.value.name,
  //     };
  //     await saveHospitalInfoUsecase.execute(hospitalInfo);
  //     return SATResult.success(hospitalInfo);
  //   },
  //   async validGuardianInfo() {
  //     if (!selfSignupRepoInstance) {
  //       return SATResult.failure(
  //         new SATErrorModel.FailToGetItem("셀프 회원가입 저장소가 초기화되지 않았습니다.")
  //       );
  //     }
  //     const info = await selfSignupRepoInstance.loadGuardianInfo();
  //     return SATResult.success(info);
  //   },
  //   async validPatientInfo() {
  //     if (!selfSignupRepoInstance) {
  //       return SATResult.failure(
  //         new SATErrorModel.FailToGetItem("셀프 회원가입 저장소가 초기화되지 않았습니다.")
  //       );
  //     }
  //     const info = await selfSignupRepoInstance.loadPatientInfo();
  //     return SATResult.success(info);
  //   },
  //   async validSignupInfo() {
  //     return loadSignupTotalInfoUsecase.execute();
  //   },
  //   saveGuardianInfo(guardian: SelfSignupGuardianInfo) {
  //     return saveGuardianInfoUsecase.execute(guardian);
  //   },
  //   savePatientInfo(patient: SelfSignupPatientInfo) {
  //     return savePatientInfoUsecase.execute(patient);
  //   },
  //   async issuePhoneAuthCode(phoneNumber: string) {
  //     const result = await issuePhoneAuthCodeUsecase.execute(phoneNumber);
  //     if (result.isSuccess) {
  //       phoneAuthToken = result.value.token;
  //     }
  //     return result;
  //   },
  //   async validPhoneAuthCode(code: string) {
  //     if (!phoneAuthToken) {
  //       return SATResult.failure(
  //         new SATErrorModel.FailToGetItem("휴대폰 인증 토큰이 없습니다.")
  //       );
  //     }
  //     const result = await validPhoneAuthCodeUsecase.execute(code, phoneAuthToken);
  //     if (result.isSuccess) {
  //       selfSignupToken = result.value.token;
  //     }
  //     return result;
  //   },

  //   async requestPreSingup() {
  //     const signupInfoResult = await loadSignupTotalInfoUsecase.execute();
  //     if (signupInfoResult.isFailure) {
  //       return SATResult.failure(signupInfoResult.error);
  //     }

  //     const signupInfo = signupInfoResult.value;
  //     if (
  //       !signupInfo ||
  //       !signupInfo.guardianInfo ||
  //       !signupInfo.patientInfo ||
  //       !signupInfo.hospitalInfo
  //     ) {
  //       return SATResult.failure(
  //         new SATErrorModel.FailToGetItem("사전 등록에 필요한 정보가 부족합니다.")
  //       );
  //     }

  //     const token = selfSignupToken ?? signupInfo.token ?? phoneAuthToken;
  //     if (!token) {
  //       return SATResult.failure(
  //         new SATErrorModel.FailToGetItem("사전 등록 토큰을 찾을 수 없습니다.")
  //       );
  //     }

  //     const payload: PreRegistrationRequestPayload = {
  //       patient: {
  //         fullName: signupInfo.patientInfo.name,
  //         lastName: undefined,
  //         firstName: signupInfo.patientInfo.name,
  //         birthDate: signupInfo.patientInfo.birthDate,
  //         gender: signupInfo.patientInfo.gender,
  //         memo: undefined,
  //       },
  //       guardian: {
  //         fullName: signupInfo.guardianInfo.name,
  //         lastName: undefined,
  //         firstName: signupInfo.guardianInfo.name,
  //         phone: signupInfo.guardianInfo.phoneForServer,
  //         email: signupInfo.guardianInfo.email,
  //       },
  //       hospitalCode: signupInfo.hospitalInfo.code,
  //     };

  //     const encryptedPayload: PreRegistrationEncyptedPayload = {
  //       securePayload: JSON.stringify(payload),
  //     };

  //     return createPreRegistrationUsecase.execute(token, encryptedPayload);
  //   },
  // };

  console.log("[INITIALIZE_INSTANCES] :: initializeInstances Finished");
  // 새로고침 시 세션 키 복원 교착 방지 (restore-session-key-before-render.ts 참고)
  return restoreSessionKeyBeforeRender(sessionKeyHolder).then(() => undefined);
};
